import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getCurrentRouteState (routing) {
  return ROUTING_STATE_SHAPE.getAt(routing, ['current']);
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getCurrentRouteState.js